<template>
    <v-dialog
        v-model="pdfDownload"
        width="750"
        :text="text"
        v-if="record.output.arupComputeReport_HTML"
    >
        <template v-slot:activator="{ props }">
            <v-btn
                v-bind="props"
                :variant="text ? 'text' : 'elevated'"
                :style="{ width: maxWidth ? '100%' : 'auto' }"
            >
                PDF
                <v-icon right>mdi-tray-arrow-down</v-icon>
            </v-btn>
        </template>
        <PdfDialog
            :html="record.output.arupComputeReport_HTML"
            :calcname="record.calc.fullname"
        />
    </v-dialog>
</template>
<script setup>
import { ref } from 'vue'
import PdfDialog from './PdfDialog.vue'

const props = defineProps(['text', 'record', 'maxWidth'])

const pdfDownload = ref(false)
</script>
